import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { useLocale } from 'remix-i18next/react';
import { useUrlWithQueryParams } from '#common/hooks/useUrlWithQueryParams.ts';
import { useEditableTranslation } from '#common/i18n/edit-mode.tsx';
import { useTranslatedPath } from '#common/utils/i18n.tsx';
import { useVoicePath } from '#speaker-shop/hooks/useVoicePath';

export function NavigateToHome({ className }: { className?: string }) {
    const { t } = useEditableTranslation('common');
    const translatePath = useTranslatedPath(useLocale());
    const voicePath = useVoicePath();

    const url = useUrlWithQueryParams(translatePath(voicePath('/')), [ 'variant' ]);

    return (
        <a href={url} className={clsx('flex flex-row gap-x-2 hover:cursor-pointer mb-4', className)}>
            <ArrowLeftIcon className='h-6 w-6' /> {t('navigate-to-home')}
        </a>
    );
}
